import { AuthCodeInput, useSendAuthCode } from '@gripp/shared-logic';
import { yupResolver } from '@hookform/resolvers/yup';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { InferType, object as yupObject } from 'yup';
import { Button } from '../../components/crop-circle/Button';
import {
  ControlledPhoneInput,
  PhoneValidator,
} from '../../components/forms/controlledPhoneInput';
import { Colors } from '../../themes/colors';
import { LoginProps } from './props';
import { ViewError } from './viewError';

const formSchema = yupObject({
  phone: PhoneValidator,
});

type FormData = InferType<typeof formSchema>;

export default function SmsCodeLogin(props: LoginProps) {
  const { t } = useTranslation();
  const [error] = useState<string | undefined>(undefined);
  const { sendAuthCodeAsync, isPending: isLoading } = useSendAuthCode();

  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm({
    resolver: yupResolver(formSchema),
    mode: 'onSubmit',
    defaultValues: {
      phone: undefined,
    },
  });

  const onSubmit = async (data: FormData) => {
    const input = { phone: data.phone } as AuthCodeInput;
    const handleCodeSent = props.onCodeSent ?? (() => null);
    await sendAuthCodeAsync(input, handleCodeSent, props.onRegister);
  };

  return (
    <View style={styles.wrapper}>
      <ControlledPhoneInput
        control={control}
        name="phone"
        placeholder={t('phone')}
        height={48}
        backgroundColor={Colors.role.surfaceHover}
        borderRadius={4}
      />
      <Button
        variant="rectangular"
        size="large"
        state={isValid && !isLoading ? 'active' : 'default'}
        loading={isLoading}
        onPress={handleSubmit(onSubmit)}
        style={styles.button}
      >
        {t('login.continue')}
      </Button>
      <ViewError error={error} />
    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    alignSelf: 'stretch',
    gap: 24,
  },
  button: {
    width: '100%',
  },
});
